import React from 'react';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import { FiPlusCircle, FiMinusCircle, FiSave } from "react-icons/fi";

const Columns = (props) => (
  <div style={{marginLeft: "1rem", display: "flex"}}>

    <Table striped bordered hover size="sm" responsive="sm" className="man-scroll-table man-table">
      <thead>
        <tr>
          <th style={{width: "5rem", textAlign: "center"}}>ID</th>
          <th style={{width: "10rem"}}>Table</th>
          <th style={{width: "15rem"}}>Column Name</th>
          <th style={{width: "5rem", textAlign: "center"}}>Delete</th>
        </tr>
      </thead>
      <tbody>

        {props.state.showColSummons ? props.state.summonsColumns.map((row, index) => (
          <tr>
            <td style={{width: "5rem", textAlign: "center"}} className="pt-2">
              {row.id}
            </td>

            <td style={{width: "10rem"}} className="pt-2">
              Summons
            </td>

            <td>
              <Form.Control  type="text" value={row.name}
                onChange={e => props.onChanged(index, e.target.value, "columnsSummons")} />
            </td>

            <td style={{width: "5rem", textAlign: "center", color: "#dc0d0e", fontSize: "1.5rem"}}>
              <FiMinusCircle  style={{fontSize: "1.5rem", cursor: "pointer"}} className="mt-1"
                onClick={event => props.onChanged(index, "delete", "columnsSummons")}/>
            </td>
          </tr>
        )) : ""}

        {props.state.showColSheriff ? props.state.sheriffColumns.map((row, index) => (
          <tr>
            <td style={{width: "5rem", textAlign: "center"}} className="pt-2">
              {row.id}
            </td>

            <td style={{width: "10rem"}} className="pt-2">
              Sheriff Return
            </td>

            <td>
              <Form.Control  type="text" value={row.name}
                onChange={e => props.onChanged(index, e.target.value, "columnsSheriff")} />
            </td>

            <td style={{width: "5rem", textAlign: "center", color: "#dc0d0e", fontSize: "1.5rem"}}>
              <FiMinusCircle  style={{fontSize: "1.5rem", cursor: "pointer"}} className="mt-1"
                onClick={event => props.onChanged(index, "delete", "columnsSheriff")}/>
            </td>
          </tr>
        )) : ""}

        {props.state.showColJudge ? props.state.judgeColumns.map((row, index) => (
          <tr>
            <td style={{width: "5rem", textAlign: "center"}} className="pt-2">
              {row.id}
            </td>

            <td style={{width: "10rem"}} className="pt-2">
              Judgement
            </td>

            <td>
              <Form.Control  type="text" value={row.name}
                onChange={e => props.onChanged(index, e.target.value, "columnsJudge")} />
            </td>

            <td style={{width: "5rem", textAlign: "center", color: "#dc0d0e", fontSize: "1.5rem"}}>
              <FiMinusCircle  style={{fontSize: "1.5rem", cursor: "pointer"}} className="mt-1"
                onClick={event => props.onChanged(index, "delete", "columnsJudge")}/>
            </td>
          </tr>
        )) : ""}

        {props.state.showColOther ? props.state.otherColumns.map((row, index) => (
          <tr>
            <td style={{width: "5rem", textAlign: "center"}} className="pt-2">
              {row.id}
            </td>

            <td style={{width: "10rem"}} className="pt-2">
              Other
            </td>

            <td>
              <Form.Control  type="text" value={row.name}
                onChange={e => props.onChanged(index, e.target.value, "columnsOther")} />
            </td>

            <td style={{width: "5rem", textAlign: "center", color: "#dc0d0e", fontSize: "1.5rem"}}>
              <FiMinusCircle  style={{fontSize: "1.5rem", cursor: "pointer"}} className="mt-1"
                onClick={event => props.onChanged(index, "delete", "columnsOther")}/>
            </td>
          </tr>
        )) : ""}
      </tbody>
    </Table>

    <FiPlusCircle className="add-man-button ml-4" onClick={e => props.onAddEntry("columns")}/>

    <FiSave className="save-man-button ml-4" onClick={e => props.onSaveEntry("columns")}
      style={{display: props.changed ? "" : "none"}}/>

  </div>
);

export default Columns;
